import { appendIf } from '@btime/helpers'
import { useTranslation } from 'react-i18next'

import {
  useCompleteServiceOrdersAction,
  useCreateServiceOrderChildAction,
  useEditServiceOrderAction,
  useEditServiceOrderUserAction,
  useEditServiceOrdersStatusAction,
  useRemoveServiceOrderAction,
  useServiceOrderExecutionAction,
  useServiceOrderResumeAction
} from './actions'
import { useIsMaster } from '@btime/react-session'
import { useNavigation } from '../../contexts/NavigationContext'
import { useSubdomain } from '../../contexts/UrlProvider'
import { useCloseModal } from '../../../components/modals/ModalsContext'

export const useServiceOrderFastActionsList = (item, opts = {}) => {
  const { t } = useTranslation('common')
  const hide = opts.hide || []
  const onClose = useCloseModal()

  const isMaster = useIsMaster()
  const execution = useServiceOrderExecutionAction(item, true)
  const editUser = useEditServiceOrderUserAction(item)
  const editStatus = useEditServiceOrdersStatusAction([item.id])
  const resume = useServiceOrderResumeAction(item, true)
  const createChild = useCreateServiceOrderChildAction(item)
  const edit = useEditServiceOrderAction(item)
  const remove = useRemoveServiceOrderAction(item)
  const complete = useCompleteServiceOrdersAction(item)

  const navigate = useNavigation()
  const ws = useSubdomain()

  const generatePDF = serviceOrder => {
    onClose()

    if (ws === 'srsms') {
      navigate(`/pdfs/1/srsms/relatorio/${serviceOrder.id}`)
    } else {
      navigate(`/service-orders/${serviceOrder.id}/pdf?autoPrint=true`)
    }
  }

  const completeAction = {
    label: t('complete'),
    onClick: () => complete.click(),
    icon: 'BsCheckCircle',
    color: 'green'
  }

  if (['open', 'received'].includes(item.status?.name)) {
    return [
      ...appendIf(isMaster, completeAction),
      execution.hasPermission
        ? { label: t('execute'), onClick: execution.click, icon: 'BsCheckCircle' }
        : { label: t('changeUser'), onClick: editUser.click, icon: 'BsPerson' },
      ...appendIf(edit.hasPermission, {
        label: t('edit'),
        onClick: () => edit.click(item),
        icon: 'BsPencil'
      }),
      ...appendIf(editStatus.hasPermission, {
        label: t('cancel'),
        onClick: () => editStatus.click('canceled'),
        icon: 'BsXOctagon',
        color: 'red'
      })
    ]
  }

  if (['pause'].includes(item.status?.name)) {
    return [
      ...appendIf(isMaster, completeAction),
      ...appendIf(execution.hasPermission, { label: t('execute'), onClick: execution.click, icon: 'BsCheckCircle' })
    ]
  }

  if (['completed', 'approved'].includes(item.status?.name)) {
    return [
      ...appendIf(!hide.includes('pdf') && resume.hasPermission, {
        label: t('generatePDFSummary'),
        onClick: () => generatePDF(item),
        icon: 'BsFileRichtext'
      }),
      ...appendIf(!hide.includes('resume') && resume.hasPermission, {
        label: t('resume'),
        onClick: resume.click,
        icon: 'BsFileRichtext'
      }),
      ...appendIf(editStatus.hasPermission, {
        label: t('approval'),
        onClick: editStatus.click,
        icon: 'BsFillTagsFill'
      })
    ]
  }

  if (['pending', 'approved'].includes(item.status?.name)) {
    return [
      ...appendIf(execution.hasPermission, { label: t('execute'), onClick: execution.click, icon: 'BsCheckCircle' }),
      ...appendIf(!hide.includes('resume') && resume.hasPermission, {
        label: t('resume'),
        onClick: resume.click,
        icon: 'BsFileRichtext'
      })
    ]
  }

  if (['canceled', 'reproved', 'refused'].includes(item.status?.name)) {
    return [
      ...appendIf(!hide.includes('resume') && resume.hasPermission, {
        label: t('resume'),
        onClick: resume.click,
        icon: 'BsFileRichtext'
      }),
      ...appendIf(createChild.hasPermission, {
        label: t('createChildActivity'),
        onClick: createChild.click,
        icon: 'BsFolderPlus'
      })
    ]
  }

  if (['execution'].includes(item.status?.name)) {
    return [
      ...appendIf(isMaster, completeAction),
      ...appendIf(!hide.includes('resume') && resume.hasPermission, {
        label: t('resume'),
        onClick: resume.click,
        icon: 'BsFileRichtext'
      }),
      ...appendIf(createChild.hasPermission, {
        label: t('createChildActivity'),
        onClick: createChild.click,
        icon: 'BsFolderPlus'
      })
    ]
  }

  return []
}
